import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { NotFoundErrorComponent } from './errors/components/not-found-error/not-found-error.component'

const routes: Routes = [
  {
    path: 'accounts',
    loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
  },
  { path: '**', component: NotFoundErrorComponent },
]

/**
 * This setting will keep navigated scroll to top of any screen
 * paramsInheritanceStrategy: 'always',
 * scrollPositionRestoration: 'enabled',
 */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
